import React from 'react';
import PropTypes from 'prop-types';

const FinalPrice = ({
  className, totalPrice, discount, finalPrice,
  giftCardInputTotal, showGiftCardInputTotal, billingPrice,
  member, accompanies, westerUsePoint,
}) => {
  const discountDisplay = discount > 0 ? `-${discount.toLocaleString()}` : 0;
  const westerUsePointDisplay =
    westerUsePoint == null
      ? ''
      : `${westerUsePoint > 0 ? '-' : ''}${westerUsePoint.toLocaleString()}`;

  return (
    <div className={`subscriptionPriceContainer ${className}`}>
      <div className="subscriptionPriceBlock">
        <div className="subscriptionPriceBlockTitle kindContainer">
          <div className="subscriptionPriceBlockTitle number">代表者</div>
          <div className="subscriptionPriceBlockTitle kind">おとな</div>
        </div>
        <div className="subscriptionPriceBlockTitle price">{member.totalPrice.toLocaleString()}円</div>
      </div>
      {accompanies && accompanies.map((person, index) => (
        <div key={index} className="subscriptionPriceBlock">
          <div className="subscriptionPriceBlockTitle kindContainer">
            <div className="subscriptionPriceBlockTitle number">{`同行者${index + 1}`}</div>
            <div className="subscriptionPriceBlockTitle kind">{person.chargeKind === "ADULT" ? "おとな" : "こども"}</div>
          </div>
          <div className="subscriptionPriceBlockTitle price">{person.totalPrice.toLocaleString()}円</div>
        </div>
      ))}
      <div className="subscriptionPriceBlock">
        <div className="subscriptionPriceBlockTitle">旅行代金</div>
        <div className="boldPrice">{`${totalPrice.toLocaleString()}円`}</div>
      </div>
      {westerUsePoint !== null && (
      <div className="subscriptionPriceBlock">
        <div className="subscriptionPriceBlockTitle">WESTERポイント</div>
        <div className="boldPrice">{`${westerUsePointDisplay}円`}</div>
      </div>)}
      <div className="subscriptionPriceBlock">
        <div className="subscriptionPriceBlockTitle">割引金額</div>
        <div className="boldPrice">{`${discountDisplay}円`}</div>
      </div>
      <div className="subscriptionPriceBlock billing-amount">
        <div className="subscriptionPriceBlockTitle">ご請求金額</div>
        <div className="redPrice">{`${finalPrice.toLocaleString()}円`}</div>
      </div>
      {showGiftCardInputTotal && (
        <div className="subscriptionPriceBlock">
          <div className="subscriptionPriceBlockTitle">日本旅行ギフトカード・<br />ドリーム旅行カード利用額</div>
          <div className="redPrice">{`${giftCardInputTotal.toLocaleString()}円`}</div>
        </div>
      )}
      <div className="subscriptionPriceBlock total">
        <div className="subscriptionPriceBlockTitle">クレジットカード決済金額</div>
        <div className="totalPriceArea">
          {/* <div>税込</div> */}
          <div className="totalPrice">
            {`${billingPrice.toLocaleString()}円`}
          </div>
        </div>
      </div>
      <div className="userInfoCashItemCampaignBillingItemSup">
        ※こども（寝具なし）は事前の支払いの有無にかかわらず、<br />
        現地にて施設利用料などのお支払いが必要な場合がございます。<br />
        領収書の発行について<br />
        PCサイトのマイページにて「領収書自動発行」がご利用いただけます。
      </div>
    </div>
  );
};

FinalPrice.defaultProps = {
  className: '',
  discount: 0,
  giftCardInputTotal: 0,
  westerUsePoint: null,
};

FinalPrice.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  totalPrice: PropTypes.number.isRequired,
  discount: PropTypes.number,
  finalPrice: PropTypes.number.isRequired,
  giftCardInputTotal: PropTypes.number,
  showGiftCardInputTotal: PropTypes.bool.isRequired,
  billingPrice: PropTypes.number.isRequired,
  member: PropTypes.object.isRequired,
  accompanies: PropTypes.array.isRequired,
  westerUsePoint: PropTypes.number,
};

export default FinalPrice;
